import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addMembership } from "../../../redux/membership/action";
import {
  addMembershipValidation,
  discountaAddMembershipValidation,
} from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import MembershipAllowances, { initialUnlimitedFlags } from "./MembershipAllowances";
import "./MembershipEditor.css";
import {
  MEMBERSHIP_MARKETING_FEATURES,
  defaultMembershipMarketingFeatures,
} from "./membershipFeatures";

const AddMembership = () => {
  const [selectdurationtype, setselectdurationtype] = useState("");
  const [loading, setLoading] = useState(false);
  const [dis, setDis] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...initialUnlimitedFlags(),
      quota_note: "",
      ar_quota_note: "",
      title: "",
      ar_title: "",
      max_invoices: "",
      max_invoices1: "",
      max_invoices2: "",
      max_invoices3: "",
      max_invoices4: "",
      shopify_max_invoices: "",
      shopify_max_invoices1: "",
      shopify_max_invoices2: "",
      shopify_max_invoices3: "",
      shopify_max_invoices4: "",

      duration_type: "",
      duration: 1,
      price: "",
      discount: "",
      support_regular: 0,
      ...defaultMembershipMarketingFeatures,

    },
    validationSchema: dis
      ? discountaAddMembershipValidation
      : addMembershipValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    if (!data.discount) {
      delete data.discount;
    }
    dispatch(addMembership(data, setLoading, navigate));
  };

  const handleGenderChange = (e) => {
    const gender = e.target.value;
    setselectdurationtype(gender);
    formik.setFieldValue("duration_type", Number(gender));
  };

  console.log(formik.values,"dfsfsfs")

  return (
    <div className="p-3">
      <h3 className="pb-3">Create Membership</h3>
      <div className=" category-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <div className="row membership-editor-grid">
            <div className="col-md-5">
              <div className="col-md-12 form-group">
                <label>Membership name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>

              <div className="col-md-12 form-group">
                <label>Membership Arabic name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>

              <div className="form-group col-md-12">
                <label htmlFor="duration_type">Duration Type</label>
                <select
                  id="duration_type"
                  name="duration_type"
                  className="form-control"
                  onChange={handleGenderChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration_type}
                >
                  <option value="">Select Duration type</option>
                  <option value="1">Monthly</option>
                  <option value="2">Semi-Annual</option>
                </select>
                {formik.touched.duration_type && formik.errors.duration_type ? (
                  <div className="error">{formik.errors.duration_type}</div>
                ) : null}
              </div>
              {/* <div className="col-md-12 form-group">
                <label>Duration</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter duration"
                  name="duration"
                  id="duration"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration}
                />
                {formik.touched.duration && formik.errors.duration ? (
                  <div className="error">{formik.errors.duration}</div>
                ) : null}
              </div> */}

              <div className="col-md-12 form-group">
                <label>Price (SAR)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter price"
                  name="price"
                  id="price"
                  min="0"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.price}
                />
                {formik.touched.price && formik.errors.price ? (
                  <div className="error">{formik.errors.price}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Discount % (optional)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter discount"
                  name="discount"
                  max="100"
                  min="0"
                  id="discount"
                  onChange={(e) => {
                    formik.handleChange(e);
                    setDis(e.target.value);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.discount}
                />
                {formik.touched.discount && formik.errors.discount ? (
                  <div className="error">{formik.errors.discount}</div>
                ) : null}
              </div>
            <div className="row mb-3">
              {[["quota_note", "Plan note — English"], ["ar_quota_note", "Plan note — Arabic"]].map(([field, label]) => (
                <div className="col-md-12 form-group" key={field}>
                  <label htmlFor={field}>{label}</label>
                  <textarea id={field} name={field} rows={3} maxLength={5000} className="form-control"
                    dir={field === "ar_quota_note" ? "rtl" : "ltr"} value={formik.values[field]}
                    onChange={formik.handleChange} onBlur={formik.handleBlur} />
                </div>
              ))}
              <p className="text-muted">Optional. Leave blank to hide the note below the plan benefits.</p>
            </div>
            </div>
            <div className=" col-md-7 d-flex justify-content-center">
              <div className="table-responsive  ">
                <table className="table">
                  <tbody>
                  <MembershipAllowances formik={formik} />
                  <tr><th>Plan Benefit</th><th>Arabic Label</th><th>Included</th></tr>
                  {MEMBERSHIP_MARKETING_FEATURES.map((feature) => (
                      <tr key={feature.field}>
                        <td>{feature.label}</td>
                        <td dir="rtl">{feature.arLabel}</td>
                        <td className="checkbox-input">
                          <input
                            type="checkbox"
                            onChange={(event) => {
                              formik.setFieldValue(
                                feature.field,
                                event.target.checked ? 1 : 0
                              );
                            }}
                            checked={formik.values[feature.field] === 1}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>Business Hours Support</td>
                      <td>
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "support_regular",
                              e.target.checked ? 1 : 0
                            );
                          }}
                          checked={formik.values.support_regular === 1}
                        />
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              type="button" className="submit-btn  "
              onClick={() => {
                navigate("/membership");
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMembership;
